<template>
<div class="changePasswordScreen">
	<div class="container">
		<div class="row justify-content-center">
			<div class="col-md-12">
			<div class="card">
				<div class="card-header bg-white border-0">
					<div class="row align-items-center">
						<div class="col-8">
							<h3 class="mb-0 text-left">{{$t("forms.resetPassword.title")}}</h3>
						</div>
					</div>
					<hr>
				</div>
				<div class="card-body">
                    <div class="row">
                        <div class="col-12 text-center mb-4">
                            <h4>
                                {{$t("forms.forgotPassword.message")}}
                            </h4>
                        </div>
                    </div>                    
                    <form @submit.prevent="handleSubmit">
                        <div class="form-group row">
							<label for="password" class="col-md-4 col-form-label text-md-right">{{$t("forms.changePassword.newPasswordLabel")}}</label>
							<div class="col-md-6">
								<input type="password" v-model="password" autocomplete="new-password" name="password" class="form-control"
									:class="{ 'is-invalid': submitted && !password }" />
								<div v-show="submitted && !password" class="invalid-feedback">{{$t("forms.changePassword.newPasswordRequiredValidation")}}</div>
							</div>
						</div>

						<div class="form-group row">
							<label for="confirmPassword" class="col-md-4 col-form-label text-md-right">{{$t("forms.changePassword.confirmPasswordLabel")}}</label>
							<div class="col-md-6">
								<input type="password" v-model="confirmPassword" autocomplete="new-password" name="confirmPassword" class="form-control"
									:class="{ 'is-invalid': submitted && (!confirmPassword || (confirmPassword && password != confirmPassword))}" />
								<div v-show="submitted && !confirmPassword" class="invalid-feedback">{{$t("forms.changePassword.confirmPasswordRequiredValidation")}}</div>
								<div v-show="submitted && confirmPassword && password !== confirmPassword" class="invalid-feedback">{{$t("forms.changePassword.confirmPasswordMatchValidation")}}</div>
							</div>
						</div>

						<div class="form-group">
							<ul class="errors-list">
								<li class="d-inline-block" :key="item" v-for="item in errors">
									{{ item }}
								</li>
							</ul>
						</div>

						<div class="col-md-6 offset-md-4">
							<button type="submit" :disabled="loading" class="btn btn-primary">
								<img v-show="loading" 
									src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
								{{$t("actions.changePassword")}}
							</button>
						</div>
                    </form>
                </div>
            </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import WebApi from './../services/apiService.js';
export default {
  data() {
    return {
      code: null,
      email: null,
      password: null,
      confirmPassword: null,
      submitted: false,
      success: false,
      loading: false,
      errors: []
    };
  },
  mounted: function(){
      try{
          console.log(this);
        if(this.$route && this.$route.params){
            this.email = this.$route.params.email;
            this.code = this.$route.params.token;
        }
      } catch(error){ console.log(error); }
  },
  methods: {
    handleSubmit(/*e*/) {
        this.submitted = true;        
        if (!this.email || !this.code) {
            this.errors = [this.$t("forms.resetPassword.invalidDataValidation")]
            return;
        }
        if(this.loading) return;
        this.loading = true;
        this.errors.length = 0;
        let model = {
            email: this.email, 
            code:this.code, 
            password: this.password, 
            confirmPassword: this.confirmPassword
        };

        WebApi.resetPassword(model)
          .then(response => {
              console.log('forgot result:', response);
              if(response.data.success) {
                console.log("reset password result", response);
                this.loading = false;
                this.submitted = false;
                this.emailSentTo = this.email;
                this.email = null;
                this.success = true;
                this.$router.replace("/profile");
            } else {
                this.loading = false;
                this.success = false;
                this.errors.length = 0;
                for (const key in response.data.errors) {
                    //console.log(`${key}: ${response.data.errors[key]}`);
                    this.errors.push(response.data.errors[key]);
                }
            }
        })
        .catch(err => {
            console.log("reset password error", err);
            this.status.loading = false;
            this.errors = ['Something went wrong. Please try again.'];
        });      
    }
  }
};
</script>

<style>
	.errors-list { color: #dc3545; }
</style>